import { ChevronRight, Image as ImageIcon, MessageCircle, Trash2, RotateCcw } from "lucide-react";
import { AttentionChip } from "./RequestRow";
import { assetUrl } from "../api";

export default function AdminRequestMobileCard({ request: r, onOpen, actions }) {
  const photo = r.partPhotos?.[0] || r.photos?.[0] || r.images?.[0];
  const photoUrl = typeof photo === "string" ? photo : photo?.url || photo?.path;
  return (
    <article className="agp-admin-mobile-request">
      <button type="button" className="agp-admin-mobile-request__main" onClick={onOpen} disabled={!onOpen}>
        <div className="agp-admin-mobile-request__top">
          <strong>{r.requestId || "Request"}</strong>
          <span className="agp-admin-mobile-request__status">{r.status || "Pending"}</span>
        </div>
        <div className="agp-admin-mobile-request__body">
          <span className="agp-admin-mobile-request__image">{photoUrl ? <img src={assetUrl(photoUrl)} alt="Requested part" onError={(e) => { e.currentTarget.style.display = "none"; }} /> : <ImageIcon size={25} />}</span>
          <div className="agp-admin-mobile-request__content">
            <h3>{r.partRequired || r.notes || "Requested Part"}</h3>
            {r.partNumber && <p>Part: {r.partNumber}</p>}
            <p>{r.customerName || "Customer"}</p>
            <p>{r.rego || (r.vin ? `VIN: ${r.vin}` : "")}</p>
            <AttentionChip attention={r.attention} />
          </div>
          {onOpen && <ChevronRight className="agp-admin-mobile-request__chevron" size={19} />}
        </div>
        <div className="agp-admin-mobile-request__foot"><span>{r.createdAt ? new Date(r.createdAt).toLocaleDateString("en-AU", { day: "numeric", month: "short", year: "numeric" }) : ""}</span><span><MessageCircle size={14} /> {r.commentCount || 0} comments</span></div>
      </button>
      {actions && <div className="agp-admin-mobile-request__action">{actions}</div>}
    </article>
  );
}
